// eslint-disable-next-line deprecate/import
import Link from 'next/link';

import type { MouseEvent } from 'react';

import classNames from 'classnames';

import LinkIcon from '@uikit/icons/Link';

import { tokensInfo } from '@shared/constants/wallets';

import { Tooltip } from '@ui/uikit/components/common/Tooltip';
import { Reload } from '@ui/uikit/components/icons/mono/Reload';

import { useRounds } from '../../../model/web3Raffle/api/useRounds';
import type { CellProps } from './types';

export const RewardCell = ({ row, walletAddress }: CellProps) => {
  const { refetch, isFetching } = useRounds(walletAddress);

  const onClickLink = (e: MouseEvent) => {
    e.stopPropagation();
  };

  const onClickReload = (e: MouseEvent) => {
    e.stopPropagation();

    if (isFetching) {
      return;
    }

    void refetch();
  };

  if (row.prizeInSqr.value > 0) {
    const sqrToken = tokensInfo.SQR;

    return (
      <div className="text-base-text-primary text-caption-sm-a flex gap-4 max-md-msq:gap-2 items-center">
        <div>{row.prizeInSqr.formatted}</div>
        {!!walletAddress && (
          <Tooltip
            side="top"
            trigger={
              <Link
                onClick={onClickLink}
                href={`https://bscscan.com/token/${sqrToken.contractsAddresses.token}?a=${walletAddress}`}
                target="_blank"
                className="msq-btn msq-btn-secondary msq-btn-icon-sm"
              >
                <LinkIcon className="icon-xs text-base-text-primary" />
              </Link>
            }
            caption="View Transaction"
          />
        )}
      </div>
    );
  }

  return (
    <div className="text-base-text-quaternary text-caption-sm-a">
      {row.isPrizeDispersed ? (
        'No Reward'
      ) : (
        <div className="flex gap-2 items-center">
          <div className="text-base-text-quaternary">Calculating...</div>
          <Tooltip
            side="top"
            trigger={
              <button
                type="button"
                data-skeleton-target="base"
                className={classNames(
                  'msq-btn msq-btn-secondary msq-btn-icon-sm',
                  isFetching && 'msq-btn-loading',
                )}
                onClick={onClickReload}
              >
                <Reload className="icon-xs text-base-text-primary" />
              </button>
            }
            caption="Reload"
          />
        </div>
      )}
    </div>
  );
};
